export const isIE11 = () => Boolean(window.MSInputMethodContext) && Boolean(document.documentMode)
// Matching `https://demo[anything].clearmetal.com|org`
export const isDemo = () => window.location.href.match(/^https:\/\/demo.*\.clearmetal\.(com|org)/)
